import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import "./poll_and_survey.css";
import api from "../../../config/api";
import config from "../../../config/config";
import { getCurrentLoggedInSessionToken } from "../../../config/userPool";
import { Dialog } from "@progress/kendo-react-dialogs";
import moment from "moment";
import momentTZ from 'moment-timezone';
import {
  createAndUpdatePollSurvey,
  fetcheSurveyDetail
} from "../../../store/poll_and_survey";
import { useDispatch, useSelector } from "react-redux";
import { POLL_SURVEY_ADD, POLL_SURVEY_LIST } from "../../../routes";
import { AddSurveyHeader } from "./add_header";
import { AddSurveySteps } from "./add_steps";
import { AddPollSurveySteps } from "./add_steps";
import { Notification_Details } from "./view/notification";
import { Button } from "@progress/kendo-react-buttons";
import { Icon } from "@progress/kendo-react-common";
import NextIcon from "../../../assets/communication/NextIcon.svg";
import { PollQuestionList, surveyTypes } from "./view/question_lists";
import { RecipientsForm } from "./recipients/recipients";
import { CollaboratorForm } from "./recipients/collaborator";
import { Loader } from "@progress/kendo-react-indicators";
import { ReviewAndPublish } from "./review_publish/review_and_publish";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";

export const AddSurvey = () => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const [selected_tab, setSelectedTab] = useState(
    parseInt(query.get("state", 0)) || 0
  );
  const [id, setId] = useState(
    query.get("id", "")
  );

  const userPermissions = getUserPermission();

  const AddPermssion = checkPermission(
    userPermissions,
    "survey.submit_survey"
  );

  const permssionAsCollaborator = checkPermission(
    userPermissions,
    "survey.view_as_collaborator"
  );

  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);
  const [recipientUsers, setRecipientUsers] = useState([]);
  const [recipientSelectedState, setRecipientSelectedState] = React.useState({});

  const [collaboratorUsers, setCollaboratorUsers] = useState([]);
  const [collaboratorSelectedState, setCollaboratorSelectedState] = React.useState({});

  const [loading, setLoading] = useState(false);
  const [showDateError, setShowDateError] = useState(false);
  const [errors, setErrors] = useState(false);
  const [showValidateError, setShowValidateError] = useState(false);
  const [enQuestions, setEnQuestions] = useState([]);
  const [zhQuestions, setZhQuestions] = useState([]);
  const [selected_dist, setSelected_dist] = useState("user_group");
  const [selected_dist_collaborator, setSelected_dist_collaborator] = useState("user_group");

  const [showError, setShowError] = useState({
    title: "",
    description: "",
    start_date: new Date(),
    start_time: "",
    end_date: new Date(),
    end_time: "",

  });
  const [disabled, setDisabled] = useState(false);

  const [editData, setEditData] = useState({
    status: "draft",
    title: "",
    description: "",
    start_date: "",
    start_time: "",
    end_date: "",
    end_time: "",
    user_visibility: true,
    recipient: [],
    collaborator: [],
    questions_en: [],
    questions_zh: []
  });

  const getData = async () => {

    if (id) {
      dispatch(fetcheSurveyDetail(id)).then((res) => {

        if (res.payload.status != 'draft' && res.payload.status != 'pendingapproval' && res.payload.status != 'scheduled') {
          navigate(POLL_SURVEY_LIST);
          return;
        }

        const updatedQuestionEn = res.payload.questions_en.map((question, index) => {
          const qtype = surveyTypes.find(type => type.value === question.qtype) || "Unknown";

          if (question.qtype == 'branching') {
            const questionLists = res.payload.questions_en.filter(q => q.qtype !== "branching")

            const updatedOptions = question.options.map(option => ({
              ...option,
              question_id: questionLists.find(q => q.qid === option.question_id)
            }));


            return {
              ...question,
              qtype: qtype,
              options: updatedOptions,
              expandable: index === 0,
            };
          } else {
            const updatedOptions = question.options.map(option => ({
              ...option,
              type: option.value.toLowerCase() === "other" ? "other" : "key"
            }));



            return {
              ...question,
              qtype: qtype,
              options: updatedOptions,
              expandable: index === 0,
            };
          }

        });

        const updatedQuestionZh = res.payload.questions_zh.map((question, index) => {
          const qtype = surveyTypes.find(type => type.value === question.qtype) || "Unknown";

          if (question.qtype == 'branching') {
            const questionLists = res.payload.questions_zh.filter(q => q.qtype !== "branching")

            const updatedOptions = question.options.map(option => ({
              ...option,
              question_id: questionLists.find(q => q.qid === option.question_id)
            }));


            return {
              ...question,
              qtype: qtype,
              options: updatedOptions,
              expandable: index === 0,
            };
          } else {
            const updatedOptions = question.options.map(option => ({
              ...option,
              type: option.value.toLowerCase() === "other" ? "other" : "key"
            }));



            return {
              ...question,
              qtype: qtype,
              options: updatedOptions,
              expandable: index === 0,
            };
          }
        });

        setZhQuestions(updatedQuestionZh);
        setEnQuestions(updatedQuestionEn);

        setRecipientUsers(res.payload.recipient);
        setCollaboratorUsers(res.payload.collaborator);


        const formattedRecipients = res.payload.recipient.reduce((acc, recipient) => {
          acc[parseInt(recipient.id, 10)] = true;
          return acc;
        }, {});

        setRecipientSelectedState(formattedRecipients);


        const formattedCollaborator = res.payload.collaborator.reduce((acc, collaborator) => {
          acc[parseInt(collaborator.id, 10)] = true;
          return acc;
        }, {});

        setCollaboratorSelectedState(formattedCollaborator);

        setEditData((prevData) => ({
          ...prevData,
          title: res.payload.title,
          description: res.payload.description,
          start_date: momentTZ.tz(res.payload.start_date, "YYYY-MM-DD", 'Asia/Singapore').local().toDate(),
          start_time: momentTZ.tz(`${res.payload.start_date} ${res.payload.start_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate(),
          end_date: momentTZ.tz(res.payload.end_date, "YYYY-MM-DD", 'Asia/Singapore').local().toDate(),
          end_time: momentTZ.tz(`${res.payload.end_date} ${res.payload.end_time}`, "YYYY-MM-DD hh:mmA", 'Asia/Singapore').local().toDate(),
          recipient: res.payload.recipient,
          collaborator: res.payload.collaborator,
          user_visibility: res.payload.user_visibility,

        }));

      });
    } else if (enQuestions.length == 0 && zhQuestions.length == 0) {
      setEnQuestions([
        {
          qid: `${Date.now()}`,
          qtitle: "",
          qtype: {
            "value": "single-choice",
            "name": "Single Choice"
          },
          options: [],
          is_required: false,
          expandable: true,

        },
      ]);

    }
  };


  useEffect(() => {
    getData();
  }, [id]);


  const backtoInformation = () => {
    query.set("state", 0);
    navigate(POLL_SURVEY_ADD + "?" + query.toString());
  };

  const checkMandatoryFields = () => {
    setShowDateError(false);

    const { start_date, start_time, end_date, end_time, title, description, questions_en, questions_zh } = editData;

    if (!start_date || !start_time || !end_date || !end_time || !title) {
      console.error("All date and time fields must be filled.");
      setShowRequiredFieldError(true);
      return true;

    }

    const startDateTime = moment(`${moment(start_date).format("YYYY-MM-DD")} ${moment(start_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();
    const endDateTime = moment(`${moment(end_date).format("YYYY-MM-DD")}T${moment(end_time).format("hh:mmA")}`, "YYYY-MM-DD hh:mmA").toDate();

    if (endDateTime <= startDateTime) {
      setShowDateError(true);
      return true;
    }

    if (selected_tab === 1 && (enQuestions.length === 0 && zhQuestions.length === 0)) {
      setShowRequiredFieldError(true);
      return true;
    }

    if (selected_tab === 1) {

      let hasEmptyField = false;

      enQuestions.forEach((v) => {
        if (!v.qtitle?.trim() || !v.qtype?.value?.trim()) {
          hasEmptyField = true;
          return;
        }
        if(v.options.length == 0 && v.qtype?.value !== "open-ended" && v.qtype?.value !== "star-rating"){
          hasEmptyField = true;
          return;
        }
        v.options.forEach((vv) => {
          if (!vv.value?.trim()) {
            hasEmptyField = true;
          }
          if (v.qtype.value === "branching" && !vv.question_id) {
            hasEmptyField = true;
          }
        });
      });

      zhQuestions.forEach((v) => {
        if (!v.qtitle?.trim() || !v.qtype?.value?.trim()) {          
          hasEmptyField = true;
          return;
        }
        if(v.options.length == 0 && v.qtype?.value !== "open-ended" && v.qtype?.value !== "star-rating"){
          hasEmptyField = true;
          return;
        }
        v.options.forEach((vv) => {
          if (!vv.value?.trim()) {
            hasEmptyField = true;
          }
          if (v.qtype.value === "branching" && !vv.question_id) {
            hasEmptyField = true;
          }
        });
      });

      if (hasEmptyField) {
        console.log('hasEmptyField '+hasEmptyField);
        
        setShowValidateError(true);
        setShowRequiredFieldError(true);
        return true;
      }

    }

    if (selected_tab === 2 && editData.recipient.length === 0) {
      setShowRequiredFieldError(true);
      return true;
    }

    // if (selected_tab === 3 && editData.collaborator.length === 0) {
    //   setShowRequiredFieldError(true);
    //   return true;
    // }

  };

  const sortQuestion = (questions) => {
    const questionMap = {};
    const referencedQids = new Set();

    questions.forEach(q => {
      questionMap[q.qid] = q;

      // Track all referenced questions
      if (q.qtype.value === "branching") {
        q.options.forEach(opt => {
          const linkedQid = opt.question_id?.qid || opt.question_id;
          if (linkedQid) {
            referencedQids.add(linkedQid);
          }
        });
      }
    });

    const sortedQuestions = [];
    const addedQids = new Set();

    questions.forEach(q => {
      if (referencedQids.has(q.qid)) {
        // Skip for now; it'll be added later under a branching question
        return;
      }

      // Add current question
      sortedQuestions.push(q);
      addedQids.add(q.qid);

      // Add its branching children if any
      if (q.qtype.value === "branching") {
        q.options.forEach(opt => {
          const linkedQid = opt.question_id?.qid || opt.question_id;
          if (linkedQid && questionMap[linkedQid] && !addedQids.has(linkedQid)) {
            sortedQuestions.push(questionMap[linkedQid]);
            addedQids.add(linkedQid);
          }
        });
      }
    });

    return sortedQuestions;
  };

  const handleSubmit = (isSaved) => {    

    if (checkMandatoryFields()) return;

    setLoading(true);

    let updatedData = { ...editData };

    if (id) {  // Ensures id is neither null nor empty
      updatedData.id = id;
    }

    updatedData.questions_en = enQuestions;
    updatedData.questions_zh = zhQuestions;

    updatedData.start_date = momentTZ(editData.start_date).tz("Asia/Singapore").format("YYYY-MM-DD");
    updatedData.end_date = momentTZ(editData.end_date).tz("Asia/Singapore").format("YYYY-MM-DD");


    updatedData.start_time = momentTZ(editData.start_time).tz("Asia/Singapore").format("hh:mmA");
    updatedData.end_time = momentTZ(editData.end_time).tz("Asia/Singapore").format("hh:mmA");

    if (!isSaved && selected_tab == 4) {
      updatedData.status = "pendingapproval";
    }

    let tempEnQuestion = sortQuestion(enQuestions);
    let tempZhQuestion = sortQuestion(zhQuestions);
    setEnQuestions(tempEnQuestion);
    setZhQuestions(tempZhQuestion);


    updatedData.questions_en = tempEnQuestion.map((v) => {
      var options = v.options.map((vv) => {
        if (v.qtype.value == "branching") {
          return {
            question_id: vv.question_id?.qid || vv.question_id,
            value: vv.value
          }
        } else {
          return {
            value: vv.value
          }
        }

      });
      return {
        qid: `${v.qid}`,
        qtitle: v.qtitle,
        qtype: v.qtype.value,
        options: options,
        is_required: v.is_required
      };
    });

    updatedData.questions_zh = tempZhQuestion.map((v) => {
      var options = v.options.map((vv) => {
        if (v.qtype.value == "branching") {
          return {
            question_id: vv.question_id?.qid || vv.question_id,
            value: vv.value
          }
        } else {
          return {
            value: vv.value
          }
        }
      });
      return {
        qid: `${v.qid}`,
        qtitle: v.qtitle,
        qtype: v.qtype.value,
        options: options,
        is_required: v.is_required
      };
    });


    dispatch(createAndUpdatePollSurvey(updatedData)).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {
        const saved_id = payload.data.id;

        setLoading(false);

        if (selected_tab == 4) {
          navigate(POLL_SURVEY_LIST);
        } else {
          let tab = isSaved ? selected_tab : parseInt(selected_tab) + 1;
          setSelectedTab(tab);
          setId(saved_id);
          if (saved_id) {
            query.set("id", saved_id);
          }
          query.set("state", tab);
          navigate(POLL_SURVEY_ADD + "?" + query.toString());
        }


      } else {
        console.error(res);
        setErrors(res.message);
      }
      setLoading(false);
    });
  };


  const handleNext = (isSaved) => {
    console.log(editData);

    if (checkMandatoryFields()) return;


    let tab = parseInt(selected_tab) + 1;
    setSelectedTab(tab);
    setId(id);
    if (id) {
      query.set("id", id);
    }
    query.set("state", tab);
    navigate(POLL_SURVEY_ADD + "?" + query.toString());
  };

  const callback_handleBackBtn = (e) => {

    if (parseInt(selected_tab) === 0) {
      navigate(POLL_SURVEY_LIST);
      return;
    }
    console.log('selected_tab' + selected_tab);

    const currentTab = selected_tab > 0 ? (selected_tab - 1) : 0;

    if (id) {
      query.set("id", id);
    }
    query.set("state", currentTab);

    setSelectedTab(currentTab);
    navigate(POLL_SURVEY_ADD + "?" + query.toString());
  };


  const compareDate = (data) => {
    if (
      new Date(
        `${data.start_date} ${moment(data.start_time, "hh:mmA").format(
          "HH:mm:ss"
        )}`
      ) <
      new Date(
        `${data.end_date} ${moment(data.end_time, "hh:mmA").format("HH:mm:ss")}`
      )
    ) {
      return true;
    } else {
      return false;
    }
  };



  return (
    <>
      {AddPermssion || permssionAsCollaborator ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}

          {loading && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <AddSurveyHeader
            backBtncallback={(e) => callback_handleBackBtn(e)}
            state={selected_tab}
          />
          <AddPollSurveySteps
            state={selected_tab}
            setState={setSelectedTab}
            checkMandatoryFields={checkMandatoryFields}
          />

          <div className="main-poll-survey-container">
            <div className="main-poll-survey">
              {selected_tab === 0 && (
                <Notification_Details
                  loading={loading}
                  setLoading={setLoading}
                  editData={editData}
                  setEditData={setEditData}
                  showError={showError}
                />
              )}

              {selected_tab === 1 && (
                <PollQuestionList
                  setEnQuestions={setEnQuestions}
                  enQuestions={enQuestions}
                  setZhQuestions={setZhQuestions}
                  zhQuestions={zhQuestions}
                  loading={loading}
                  setLoading={setLoading}
                  editData={editData}
                  setEditData={setEditData}
                  showValidateError={showValidateError}
                />
              )}

              {selected_tab === 2 && (
                <RecipientsForm
                  loading={loading}
                  setLoading={setLoading}
                  selected_dist={selected_dist}
                  setSelected_dist={setSelected_dist}
                  setEditData={setEditData}
                  editData={editData}
                  setUsers={setRecipientUsers}
                  users={recipientUsers}
                  setSelectedState={setRecipientSelectedState}
                  selectedState={recipientSelectedState}
                />
              )}

              {selected_tab === 3 && (
                <CollaboratorForm
                  loading={loading}
                  setLoading={setLoading}
                  selected_dist={selected_dist_collaborator}
                  setSelected_dist={setSelected_dist_collaborator}
                  setEditData={setEditData}
                  setUsers={setCollaboratorUsers}
                  users={collaboratorUsers}
                  setSelectedState={setCollaboratorSelectedState}
                  selectedState={collaboratorSelectedState}
                />
              )}

              {selected_tab === 4 && (
                <ReviewAndPublish
                  loading={loading}
                  setLoading={setLoading}
                  editData={editData}
                  setEditData={setEditData}
                  setEnQuestions={setEnQuestions}
                  enQuestions={enQuestions}
                  setZhQuestions={setZhQuestions}
                  zhQuestions={zhQuestions}
                />
              )}


            </div>

            <div className="poll-survey-footer">
              <div className="footer-left-btn-groups">
                {selected_tab !== 0 &&
                  <Button
                    className="footer-previous-btn font-family-poppins"
                    onClick={() => {
                      callback_handleBackBtn();
                    }}
                  >
                    Previous
                  </Button>
                }
                {selected_tab !== 4 &&
                  <Button
                    className="footer-save-btn"
                    onClick={(e) => {
                      handleSubmit(true);
                    }}
                    disabled={disabled}
                  >
                    Save
                  </Button>
                }
              </div>
              {selected_tab !== 4 &&
                <div className="footer-right">
                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      handleSubmit(false);
                    }}
                    disabled={disabled}
                  >
                    Next
                    <Icon>
                      <img alt="" src={NextIcon} />
                    </Icon>
                  </Button>
                </div>
              }

              {selected_tab === 4 &&
                <div className="footer-right">
                  <Button
                    className="footer-next-btn"
                    onClick={(e) => {
                      handleSubmit(false);
                    }}
                    disabled={disabled}
                  >
                    Submit
                  </Button>
                </div>
              }

            </div>
          </div>



          {showDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowDateError(false)}
            >
              <p>End Date cannot be earlier than Start Date!</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowDateError(false)}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
